import useLootMintPageSetup from 'src/hooks/useLootMintPageSetup';
import useLootMintingFunctions from 'src/hooks/useLootMintingFunctions';
import { useRouter } from 'next/router';

import React from 'react';
import dynamic from 'next/dynamic';
import { LOOT_MAIN_ADDRESS_PROD } from 'src/base/constants';

const MintPage = dynamic( () => import( '../../../ui/components/MintPage' ), {
	loading: () => <p>Loading...</p>,
	ssr: false, // This line ensures the component is only rendered client-side
});

export async function getStaticPaths() {
	// NOTE: update this as more pieces are published
	const paths = [
		{ params: { pieceId: '0' }},
		{ params: { pieceId: '1' }},
		{ params: { pieceId: '2' }},
		{ params: { pieceId: '3' }},
		{ params: { pieceId: '4' }},
	];

	return {
		paths,
		fallback: 'blocking', // Or 'true' or 'false', depending on your use case
	};
}

export async function getStaticProps({ params }) {
	const pieceId = params.pieceId;
	const pieceData = { pieceId };
	return {
		props: {
			pieceData,
		},
		revalidate: 60, // Optional: time in seconds to revalidate and regenerate the page
	};
}

const ApepeLootMintPage = () => {
	const router = useRouter();
	const { pieceId } = router.query;

	const {
		userIsHolderAndHasUsedAllTokensButPieceIsNotAvailableToPublic,
		userIsPublicAndTokenIsNotAvailableForPublic,
		tokenConfigNotYetSet,
		priceToUse,
		raycOrZaycAddress,
		selectedVault,
		setCustomLoadingMessage,
		showLoadingOverlay,
		setShowLoadingOverLay,
		lootContract,
		tierToUse,
		mintCount,
		tokenIdToUse,
		tokenIdsToUse,
		saleStatus,
		network,
		customLoadingMessage,
		pieceMetadata,
		tierStatement,
		// copiesOwned,
		address,
		tokensUsage,
		connect,
		infoItemsData,
		setMintCount,
		maxMintCount,
		startDate,
		pricesList,
	} = useLootMintPageSetup({ pieceId });
	const { onClickMint, doneMinting } = useLootMintingFunctions({ pieceId, mintCount, setShowLoadingOverLay, setCustomLoadingMessage, priceToUse, raycOrZaycAddress, selectedVault, tokenIdToUse, tokenIdsToUse, tierToUse, lootContract });

	const isConnected = address !== undefined && address !== null;

	if ( pieceMetadata === undefined ) {
		console.warn( 'ApepeLootMintPage: pieceMetadata is undefined' );
		return <div className='text-center'>Loading...</div>;
	}

	const NftImage = () => {
		return (
			<div className="h-full">
				{/* eslint-disable-next-line @next/next/no-img-element */}
				<img
					src={pieceMetadata.image}
					alt="NFT Image"
					className="w-auto h-full mb-10"
				/>
			</div>
		);
	};


	return <div className='flex justify-center'>
		<MintPage title="new mint page"
			key={pieceMetadata.id}
			NftMainMedia={NftImage}
			address={address}
			isConnected={isConnected}
			mintButtonText="Mint Nft"
			onClickMint={onClickMint}
			mintCount={mintCount}
			startDate={startDate}
			nftImageUri={pieceMetadata.image}
			setMintCount={setMintCount}
			maxMintCount={maxMintCount}
			saleStatus={saleStatus}
			loading={showLoadingOverlay}
			nftName={pieceMetadata.name}
			nftSuccessViewLink={`https://rarible.com/token/${LOOT_MAIN_ADDRESS_PROD}:${pieceId}`}
			nftParagraph={pieceMetadata.description}
			isSuccess={doneMinting}
			loadingText="Loading..."
			tierToUse={tierToUse}
			tierStatement={tierStatement}
			mintPrice={priceToUse}
			pricesList={pricesList}
		/>
	</div>;
};

export default ApepeLootMintPage;
